export const ItemTypes = {
  CARD: 'Card'
};
